<template>
  <div class="contract-logistics-record">
    <el-radio-group v-model="formSearch.orgType" @change="getTableList">
      <el-radio-button label="">{{ $t('Common.com_all') }}</el-radio-button>
      <el-radio-button label="HQ">{{ $t('crm_contract_logistics.zong_bu') }}</el-radio-button>
      <el-radio-button label="SC">{{ $t('crm_contract_logistics.shou_hou_gong_si') }}</el-radio-button>
    </el-radio-group>
    <div class="table-bd">
      <custom-table expand tableCode="contract_logistics_records" :data="tableList" :slots="['consigneeOrgType', 'action']">
        <template slot="expand" slot-scope="scope">
          <div class="record-detail">
            <div class="record-info record-num">
              <div class="title">{{ $t('crm_contract_logistics.huo_yun_shu_liang') }}({{ $t('crm_contract_logistics.tai') }})</div>
              <div class="content">
                <div class="device-num">{{ scope.row.deviceNum }}</div>
                <div class="btn" @click="showDeviceList(scope.row)">{{ $t('crm_contract_logistics.cha_kan_xiang_qing') }}</div>
              </div>
            </div>
            <div class="record-info record-qrcode">
              <div class="title">{{ $t('crm_contract_logistics.shou_huo_er_wei_ma') }}</div>
              <div class="content">
                <div class="qrcode-img">
                  <qrcode-vue :value="`${qrCodeBaseUrl}${scope.row.deliveryCodeStr}`" :size="106"></qrcode-vue>
                </div>
                <div class="href">
                  {{ `${qrCodeBaseUrl}${scope.row.deliveryCodeStr}` }}
                </div>
                <div class="copy-link">
                  <span @click="copyLink(`${qrCodeBaseUrl}${scope.row.deliveryCodeStr}`)">{{ $t('crm_contract_logistics.fu_zhi_lian_jie') }}</span>
                </div>
              </div>
            </div>
            <div class="record-info record-transport">
              <div class="title">{{ $t('crm_contract_logistics.huo_yun_xin_xi') }}</div>
              <div class="content">
                <ul class="transport-list">
                  <li class="transport-item" v-for="(item, index) in scope.row.logisticsDetailList" :key="index">
                    <div class="date">{{ item.ftime }}</div>
                    <div class="text">
                      {{ item.context }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
        <template slot="consigneeOrgType" slot-scope="scope">
          <el-tooltip placement="bottom" effect="light">
            <div slot="content">
              <div style="padding: 2px 8px">
                <p style="font-size: 14px; line-height: 24px">{{ $t('crm_contract_logistics.shou_huo_ren') }}： {{ scope.row.consigneeName }}</p>
                <p style="font-size: 14px; line-height: 24px">{{ $t('crm_contract_logistics.dian_hua') }}： {{ scope.row.consigneePhone }}</p>
                <p style="font-size: 14px; line-height: 24px">{{ $t('crm_contract_logistics.di_zhi') }}： {{ scope.row.consigneeAddress }}</p>
              </div>
            </div>
            <el-button type="text">{{ getDicValue('crm_logistics_receive_party', scope.row.consigneeOrgType) }}</el-button>
          </el-tooltip>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button type="text" v-if="funcView.contractDetail_edit_logistics" size="mini" @click="editLogistics(scope.row)">{{ funcView.contractDetail_edit_logistics }}</el-button>
          <el-button type="text" v-if="funcView.contractDetail_send_code" size="mini" @click="sendCode(scope.row)">{{ funcView.contractDetail_send_code }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <device-list-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = ''"></device-list-dialog>
    <enter-logistics-no-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
      :contract-delivery-id="dialogModel1.orderDeliveryId"
      @success="getTableList"
    ></enter-logistics-no-dialog>
    <!-- 发送收货码 -->
    <ship-receip-code-dialog v-if="dialogVisible4" :model="dialogModel4" @close="dialogVisible4 = false"></ship-receip-code-dialog>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import apis from '@/utils/apis';
import enterLogisticsNoDialog from '@/components/enterLogisticsNoDialog.vue';
import shipReceipCodeDialog from '@/pages/crm/components/ship_receipCode_dialog.vue';
import deviceListDialog from './device_list_dialog.vue';

export default {
  components: {
    enterLogisticsNoDialog,
    QrcodeVue,
    deviceListDialog,
    shipReceipCodeDialog,
  },
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      // 发送收货码
      dialogVisible4: false,
      dialogModel4: {},
      partyDic: {},
      formSearch: {
        bizId: '',
        bizClass: '',
        orgType: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: null,
      qrCodeBase: {},
      classMap: {
        trail_order: 10, // 试用订单
        leasing_contract: 20, // 租赁合同
        lease_renewal_contract: 21, // 续租租赁
        frame_contract: 30, // 框架协议
        frame_order: 31, // 协议订单
        lease_sales_order: 40, // 租售订单
      },
    };
  },
  computed: {
    qrCodeBaseUrl() {
      const site = document.location.origin;
      //  const site='https://tback.ice980.com'
      const url = this.qrCodeBase[site];
      return `${url}?No=`;
    },
  },
  mounted: function () {
    this.formSearch.bizId = this.getJump('contractId');
    this.formSearch.bizClass = this.getJump('contractClass');
    this.approveType = this.getJump('approveType');
    if (this.approveType && !this.formSearch.bizClass) {
      this.formSearch.bizClass = this.classMap[this.approveType];
    }
    this.getTableList();
    this.getFuncView();
    this.getDictionary('crm_logistics_receive_party,crm_logistics_qrcode_address', (data) => {
      this.partyDic = this.$listTransObject(data.crm_logistics_receive_party);
      this.qrCodeBase = this.$transformDicValue(data.crm_logistics_qrcode_address);
    });
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.$getJSON(apis.LogisticsPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 物流设备弹窗
    showDeviceList(row) {
      this.dialogModel.title = this.$t('crm_contract_logistics.she_bei_xin_xi');
      this.dialogModel.customShipmentNum = row.customShipmentNum;
      this.dialogVisible = true;
    },
    // 编辑物流弹窗
    editLogistics(row) {
      this.dialogModel1 = {
        title: this.$t('crm_contract_logistics.bian_ji_wu_liu'),
        companyName: row.logisticsCompanyName,
        companyCode: row.logisticsCompanyCode,
        orderNo: row.shipmentNum,
        orderDeliveryId: row.orderDeliveryId,
      };
      this.dialogVisible1 = true;
    },
    sendCode(row) {
      this.dialogModel4 = {
        title: this.$t('crm_contract_logistics.fa_song_shou_huo_mao', [row.customShipmentNum]),
        data: row,
      };
      this.dialogVisible4 = true;
    },
    // 拷贝地址
    copyLink(link) {
      this.$copyToClip(link, this.$t('Common.com_copy_success'));
    },
  },
};
</script>

<style lang="scss">
.contract-logistics-record {
  padding: 24px;
  background: #fff;

  .table-bd {
    margin-top: 16px;
  }

  .record-detail {
    $borderColor: #f2f3fb;
    padding: 8px 16px 8px 0;
    display: flex;

    .record-info {
      border: 1px solid $borderColor;
      height: 267px;
      margin-left: 16px;

      .title {
        height: 40px;
        font-size: 14px;
        font-weight: bold;
        padding-left: 16px;
        border-bottom: 1px solid $borderColor;
        line-height: 40px;
      }

      .content {
        width: 100%;
        height: 225px;
        position: relative;
        overflow-y: auto;
      }
    }

    .record-num {
      width: 183px;
      .device-num {
        line-height: 50px;
        font-size: 35px;
        color: #495057;
        margin-top: 64px;
        text-align: center;
      }
      .btn {
        margin-top: 48px;
        width: 81px;
        height: 24px;
        font-size: 12px;
        color: #6c757d;
        border: 1px solid #dee2e6;
        border-radius: 12px;
        line-height: 22px;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        &:hover {
          cursor: pointer;
        }
      }
    }

    .record-qrcode {
      width: 210px;

      .qrcode-img {
        $r: 106px;
        width: $r;
        height: $r;
        margin-top: 17px;
        margin-left: auto;
        margin-right: auto;
      }

      .href {
        color: #495057;
        font-size: 12px;
        width: 178px;
        text-align: center;
        line-height: 17px;
        margin-top: 23px;
        margin-left: auto;
        margin-right: auto;
      }

      .copy-link {
        font-size: 12px;
        color: #35b8e0;
        text-align: center;
        margin-top: 9px;
        line-height: 28px;
        span {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    .record-transport {
      flex: 1;

      .transport-list {
        padding-left: 16px;
        padding-top: 11px;

        .transport-item {
          display: flex;
          font-size: 12px;
          color: #6c757d;
          line-height: 24px;
          margin-bottom: 3px;

          .date {
            width: 130px;
          }
          .text {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>
